import {
    NONE,
    ERROR,
    WARN,
    INFO,
    TRACE
} from './Logger';

export const logLevel = TRACE;
// export const logLevel = NONE;

export const PROJECT_INTERNAL_NAME = 'tpilbingo';
export const PROJECT_EXTERNAL_NAME = 'TPIL Bingo';

export let FRONTEND_BASE_URL;
if (process.env.NODE_ENV === 'development') {
    FRONTEND_BASE_URL = 'localhost:3000';
} else {
    FRONTEND_BASE_URL = `${PROJECT_INTERNAL_NAME}.djvk.net`;
}



// WEBPACK FOOTER //
// ./src/lib/Constants.js